import React from "react";
import styles from "../nav/Footer.module.scss";

const Footer: React.FC = () => {
  return (
    <footer>
      <div className={styles["footer"]}>
        <div className={styles["footer__copywrite"]}>
          &#169; 2020 Sonic Boom Entertainment Inc.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
